<section class="dashboard_content_sec">
    <div class="dashboard_bred_crumb">
        <ul>

            <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg"></li>
            <li>Enquiries listing</li>
        </ul>
    </div>


    <div infiniteScroll [infiniteScrollDistance]="10" [infiniteScrollThrottle]="100" (scrolled)="loadMoreEnquiries()">

        <div *ngIf="dataLoader" class="custom-loader custom_logo_loader no-datas">
            <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 10%;" />
        </div>

        <ng-container *ngIf="!dataLoader">
            <ng-container *ngIf="myEnquiryJob?.length > 0; else noData">
                <!---jobList Item-->
                <section class="master_add_sec  mb-3" *ngFor="let x of myEnquiryJob;trackBy: trackByJobId;">
                    <div class="dashBoard-joblist-sec">
                        <div style="cursor: pointer;" class="job-box-company-detail-dashboard d-flex mb-4">
                            <div>
                                <div class="jobcompanyLogo">

                                <ng-container *ngIf="!x?.job_profiles?.post_anonymously; else anonymousImg"> 
                                    <img *ngIf="x?.job_profiles?.profile_image?.length > 0; else showLetter"
                                        [src]="x?.job_profiles?.profile_image[0]?.url" class="profile-img">
                                    <ng-template #showLetter>
                                        <div class="fallback-avatar">
                                            <span class="text-initials"> {{ getInitial(x?.job_profiles?.full_name) }} </span>
                                        </div>
                                    </ng-template>
                                </ng-container>

                                <ng-template #anonymousImg>
                                    <ng-container *ngIf="x?.job_profiles?.post_anonymously">
                                        <img class="talent-avatars" *ngIf="x?.job_profiles?.dental_professional?.gender === 'male'; else femalePlaceholder"
                                            src="../../../../../../../assets/images/social/male_avatar.png " />
                                        <ng-template #femalePlaceholder>
                                            <img class="talent-avatars"
                                                *ngIf="x?.job_profiles?.dental_professional?.gender === 'female';else defaultPlaceholder"
                                                src="../../../../../../../assets/images/social/female_avatar.png" />
                                        </ng-template>
                                        <ng-template #defaultPlaceholder> 
                                            <div style="background-color:#0f0e0e26; height: 100%;width: 100%;border-radius: 50%;">
                                                </div>
                                     </ng-template>
                                
                                    </ng-container>
                                </ng-template>
                                    
                                </div>
        
        
                            </div>
                            <div class="ml-3">
                                <h3>{{x?.job_profiles?.profession_type}}</h3>
                                <h4 *ngIf="!x?.job_profiles?.post_anonymously;">{{x?.job_profiles?.full_name}}</h4>
                                <h4>{{x?.job_profiles?.state}}</h4>
        
                            </div>
                            <div class="d-flex align-self-baseline flex-column ml-auto text-right">
                                <div class="mb-auto ml-auto">
        
                                    <button mat-icon-button *ngIf="loginDetails.type !== 'ADMIN'" [matMenuTriggerFor]="menu1"
                                        (click)="$event.stopPropagation()">
                                        <mat-icon>more_horiz</mat-icon>
                                    </button>
        
                                    <mat-menu #menu1="matMenu" class="table-action-btn">
        
                                        <!-- <button type="button" class="view" mat-menu-item
                                            [routerLink]="['/jobseek/jobseeks/talents', x?.job_profiles?.dental_professional_id]">
                                            <span>View Talent Profile</span>
                                        </button> -->
        
                                        <button type="button" class="view" mat-menu-item
                                            (click)="viewTalentProfile(x?.job_profiles?.id)">
                                            <span>View Talent Profile</span>
                                        </button>
        
                                    </mat-menu>
        
                                </div>
                                <p class="mt-5">Created : {{x.created_at | date : 'dd-MM-yyyy'}}</p>
                            </div>
                        </div>
                        <span class="EmploymentType" *ngIf="x?.job_profiles?.work_type">
                            <span class="fullTime" *ngFor="let type of x?.job_profiles?.work_type">
                                {{ type }}
                            </span>
                        </span>
        
                        <div class="d-flex" style="margin-top: 15px;">
                            <div class="mr-auto" style="min-width: 180px;">
                                <!-- <ng-container *ngIf="x.status === 'APPROVE'&& loginDetails.type!=='ADMIN'; else emptySpace"> -->
        
                                <!-- <button *ngIf="x?.matchedStatus" class="fullTime" style="border: none;"  >
                                   
                                    <ng-container >
                                        {{ x.matchedStatus }}
                                    </ng-container>
                                   
                                </button> -->
        
                                <button class=" blueThemeBtn" style="border: none; margin-left: 5px;"
                                    (click)="messageAcordion(x)" [class.highlight-border]="openAccordionId === x?.id"> Message
                                </button>
        
                                <button class=" blueThemeBtn" style="border: none; margin-left: 5px;"
                                    (click)="EnquiryAcoordion(x)" [class.highlight-border]="openEnquiryAccordionId === x?.id">
                                    Enquiry </button>
        
                                <!-- </ng-container> -->
        
                                <!-- <ng-template #emptySpace>
                                <div style="height: 36px;"></div>
                            </ng-template> -->
                            </div>
        
                            <!-- View Details Button -->
                            <div class="blueThemeBtn"
                                [routerLink]="['/jobseek/jobseeks/talents', x?.job_profiles?.dental_professional_id]">View
                                Details</div>
                        </div>
        
                        <hr>
                        <!-- Message -->
        
                        <div class="message-accordion" *ngIf="openAccordionId === x.id">
                            <div class="messages-container">
        
                                <div *ngIf="loaderMessage" class="custom-loader custom_logo_loader no-datas">
                                    <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 10%;" />
                                </div>
                                <!-- Loop through messages -->
                                <div *ngIf="!loaderMessage">
                                    <ng-container *ngIf="displayMessage?.length > 0; else noMessage">
        
                                        <div *ngFor="let message of displayMessage"
                                            [ngClass]="message.message_from === loginDetails?.id ? 'message-right' : 'message-left'">
        
                                            <div class="message-bubble">
                                                <div class="message-header">
        
        
                                                    <ng-container *ngIf="message?.message_from === loginDetails?.id">
                                                        <ng-container *ngIf="loginDetails?.logo?.url; else companyInitials">
                                                            <img class="profile-image" [src]="loginDetails?.logo?.url">
                                                        </ng-container>
                                                        <ng-template #companyInitials>
                                                            <div class="profile-initials" style="background-color:#ef6a30 ;">
                                                                <span class="text-initials"> {{ getInitial(loginDetails?.name)
                                                                    }} </span>
                                                            </div>
                                                        </ng-template>
                                                    </ng-container>
        
        
                                                    <ng-container *ngIf="message?.message_from !== loginDetails?.id">
                                                        <ng-container
                                                            *ngIf="x?.job_profiles?.dental_professional?.profile_image?.url; else profInitials">
                                                            <img class="profile-image"
                                                                [src]="x?.job_profiles?.dental_professional?.profile_image?.url">
                                                        </ng-container>
                                                        <ng-template #profInitials>
                                                            <div class="profile-initials" style="background-color:#007bff;">
                                                                <span class="text-initials"> {{
                                                                    getInitial(x?.job_profiles?.full_name) }} </span>
                                                            </div>
                                                        </ng-template>
                                                    </ng-container>
        
        
        
                                                    <!-- <img class="profile-image" src="{{x.logo}}" alt="Profile Image"> -->
                                                    <span class="message-date">{{ message?.created_at | date :'medium' }}</span>
                                                    <button mat-icon-button
                                                        *ngIf="message.message_from === loginDetails?.id && !message?.deleted_status"
                                                        [matMenuTriggerFor]="message1" (click)="$event.stopPropagation()">
                                                        <mat-icon>more_horiz</mat-icon>
                                                    </button>
                                                </div>
                                                <div class="message-data">
                                                    <p class="message-text" *ngIf="!message?.deleted_status">{{ message.message
                                                        }}</p>
                                                    <p class="message-text" *ngIf="message?.deleted_status">This message was
                                                        deleted</p>
                                                </div>
                                                <p class="message-date"
                                                    *ngIf="!message?.deleted_status && message.created_at !== message.updated_at">
                                                    Edited</p>
                                            </div>
        
        
        
                                            <mat-menu #message1="matMenu" class="table-action-btn">
        
                                                <button type="button" class="view" mat-menu-item (click)="editMessage(message)">
                                                    <span>Edit</span>
                                                </button>
                                                <button type="button" class="view" mat-menu-item
                                                    (click)="deleteMessage(message.id)">
                                                    <span>Delete</span>
                                                </button>
        
                                            </mat-menu>
                                        </div>
                                    </ng-container>
                                </div>
        
                                <ng-template #noMessage>
                                    <div class="no-datas"> No messages </div>
                                </ng-template>
        
                            </div>
                            <div class="message-input-container">
                                <input type="text" [(ngModel)]="newMessage" placeholder="Type a message..." />
                                <!-- <button class="send-button" (click)="sendMessage(x)">Send</button> -->
                                <button class="send-button"
                                    (click)="EditedMessageId? UpdateMessage(EditedMessageId) :sendMessage(x)">
                                    <mat-icon class="send-icon">send</mat-icon>
                                </button>
        
                            </div>
                        </div>
        
        
                        <!-- Accordion Enquiry -->
                        <div class="message-accordion" *ngIf="openEnquiryAccordionId === x.id"
                            style="max-height: 200px; overflow-y: auto;">
                            <div class="messages-container">
        
                                <div *ngIf="loaderEnquiry" class="custom-loader custom_logo_loader no-datas">
                                    <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 10%;" />
                                </div>
        
                                <div *ngIf="!loaderEnquiry">
                                    <ng-container *ngIf="enquiryData?.length > 0; else noEnquiry">
                                        <div *ngFor="let enquiry of enquiryData">
                                            <div class="message-right" style="max-height: 200px;">
                                                <div class="message-bubble">
                                                    <div class="message-header">
                                                        <!-- <img class="profile-image" [src]="loginDetails?.profile_image.url">
                                                                      -->
        
        
                                                        <img class="profile-image"
                                                            *ngIf="loginDetails?.logo?.url; else profInitialsEnquiry"
                                                            [src]="loginDetails?.logo?.url">
        
                                                        <ng-template #profInitialsEnquiry>
                                                            <div class="profile-initials" style="background-color:#007bff;">
                                                                <span class="text-initials"> {{ getInitial(loginDetails?.name)
                                                                    }}
                                                                </span>
                                                            </div>
                                                        </ng-template>
        
                                                        <span class="message-date">{{ enquiry?.created_at | date :'medium' }}
                                                        </span>
                                                    </div>
                                                    <div class="message-data">
                                                        <p class="message-text">{{enquiry.enquiry_description}}</p>
                                                    </div>
        
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
        
                                <ng-template #noEnquiry>
                                    <div class="no-datas"> No enquiries </div>
                                </ng-template>
                            </div>
                        </div>
        
                    </div>
                </section>
            </ng-container>
        
            <div *ngIf="loading && myEnquiryJob.length > 0" class="loading-more" fxLayout="row" fxLayoutAlign="center center">
                <img src="../../../../../assets/images2/loader.gif" alt="Loading more..." loading="lazy" width="80px" />
            </div>
        
            <!-- No more data -->
            <div *ngIf="endOfData && !loading && myEnquiryJob.length > 0" class="text-center py-3 text-muted">
                You've reached the end — no more talents enquiries to display
            </div>
        
        </ng-container>

    <ng-template #noData>
        <div class="no-data-wrapper">
            <img src="../../../../../assets/images/icons/no_tasks.svg" alt="No records illustration"
                class="no-data-image" />
            <div class="no-record-text">
                No talents enquiries available at the moment
            </div>
        </div>
    </ng-template>

          

    </div>

</section>